<template>
  <div id="page_app">
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">Add News</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container pa-0>
              <v-layout fluid row wrap>
                <v-flex lg6 sm6 xs12 pt-0 pb-0>
                  <v-text-field label="News Title" name="name" v-model="addnews.title"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12 pt-0 pb-0>
                  <v-select
                    label="Status"
                    item-text="text"
                    item-value="status"
                    v-model="addnews.status"
                    :items="statuses"
                  ></v-select>
                </v-flex>
                <v-flex lg12 sm12 xs12 pt-0 pb-0>
                  <v-text-field label="Breaf" name="breaf" v-model="addnews.breaf"></v-text-field>
                </v-flex>
                <v-flex sm12>
                  <quill-editor
                    class="quill"
                    :content="addnews.content"
                    @change="onEditorChange($event)"
                    :options="editorOption"
                  ></quill-editor>
                </v-flex>

                <v-flex lg12 sm12 xs12 pt-0 pb-0>
                  <input
                    hidden
                    name="imageupload"
                    type="file"
                    accept="image/*"
                    ref="imageupload"
                    v-on:change="upload($event.target.files)"
                  >
                </v-flex>

                <v-flex lg12 sm12 xs12 pt-0 pb-0>
                  <img
                    id="imgnewsedit"
                    class="imgslide"
                    src="https://placehold.co/600x150"
                    alt="image"
                    @click="openfile()"
                    width="100%"
                    height="150"
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeform()">Cancel</v-btn>
          <v-btn color="success" :loading="loading" @click="simpanForm(addnews)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar elevation="0">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-spacer/>
              <v-btn color="success" @click.native="getNews()">
                <v-icon dark>refresh</v-icon>Refresh
              </v-btn>
              <v-btn class="ml-2" color="success" @click.native="openmodal()">
                <v-icon dark>add</v-icon>Add
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="newslist"
                class="elevation-1"
                item-key="id"
                show-select
                :loading="loading"
                v-model="complex.selected"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:item.image="{ item }">
                  <div class="ma-2">
                    <v-img :src="item.image" contain
                           aspect-ratio="1.5" class="pa-2">
                    </v-img>
                  </div>
                </template>

                <template v-slot:item.update_at="{ item }">
                  <div class="ma-2">
                      {{formattanggal(item.update_at)}}
                  </div>
                </template>
                <template v-slot:item.status="{ item }">
                  <div class="ma-4 text-xs-left">
                    <v-chip
                            v-if="item.status===1"
                            color="green"
                            small
                            text-color="white"
                    >{{ statusformat(item.status) }}</v-chip>
                    <v-chip
                            v-else
                            color="red"
                            small
                            text-color="white"
                    >{{ statusformat(item.status) }}</v-chip>
                  </div>
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="ma-4 text-xs-left">
                    <v-btn @click.native="openFormEdit(item)" icon small>
                      <v-icon color="primary" small>edit</v-icon>
                    </v-btn>
                    <v-btn @click.native="deleteItem(item)" icon small>
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import moment from 'moment'
export default {
  components: {
    quillEditor
  },
  data: () => ({
    state_add: false,
    search: '',
    selected_combo: '',
    applist: [{ text: 'BeliStok', value: 1 }, { text: 'WartoMAx', value: 2 }],
    editorOption: {},
    valid: false,
    complex: {
      selected: [],
      headers: [
        {
          text: 'News Title',
          value: 'title'
        },
        {
          text: 'Image',
          value: 'image'
        },
        {
          text: 'Breaf',
          value: 'breaf'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'updated At',
          value: 'update_at'
        },
        {
          text: 'Action',
          value: 'action'
        }
      ],
      items: []
    },
    statuses: [
      {
        status: 1,
        text: 'Enable'
      },
      {
        status: 0,
        text: 'Disable'
      }
    ],
    delete_id: '',
    addnews: {
      appid: '',
      title: '',
      breaf: '',
      status: 1,
      content: 'isi berita...',
      image: ''
    }
  }),
  created () {
    // this.getApplist();
  },
  mounted () {
    this.getNews()
    this.resetimage()
  },
  computed: {
    ...mapState('news', ['newslist', 'dialog', 'loading']),
    ...mapState('UploadImage', ['defaultimg','loadingupload'])
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
      AddNew: 'news/AddNews',
      EditNews: 'news/EditNews',
      closeDialog: 'news/closeDialog',
      OpenDialogForm: 'news/OpenDialogForm',
      getNews: 'news/getNews',
      delete_news: 'news/DeleteNews',
      uploadImage: 'UploadImage/uploadImage',
      resetimage:'UploadImage/resetimage'
    }),
    closeform () {
      this.addnews.title = ''
      this.addnews.image = ''
      this.addnews.breaf = ''
      this.addnews.appid = ''
      this.addnews.content = ''
      this.closeDialog()
      this.state_add = false
      this.getNews()
    },
    async openFormEdit (data) {
      this.addnews = data
      this.state_add = false
      await this.OpenDialogForm()
      document.getElementById('imgnewsedit').src = this.addnews.image

    },
    formattanggal(tgl){
      return moment(tgl).format("YYYY/MM/DD HH:mm:ss")
    },
    async openmodal () {
      this.state_add = true
      this.clearform()
      await this.OpenDialogForm()
      document.getElementById('imgnewsedit').src = 'https://res.cloudinary.com/irsmax/image/upload/v1556795025/placeholderirs.png'

    },
    onEditorChange ({ html}) {
      //console.log("editor change!", html);
      this.addnews.content = html
    },
    async simpanForm (data) {
      if (this.state_add) {
        data.image=this.defaultimg
        await this.AddNew(data)
      } else {
        await this.EditNews(data)
      }
      // this.getNews();
    },
    clearform () {
      this.addnews={};
      this.addnews.title = ''
      this.addnews.image = ''
      this.addnews.breaf = ''
      this.addnews.appid = ''
      this.addnews.content = ''
     // document.getElementById('imgnewsedit').src = 'https://res.cloudinary.com/irsmax/image/upload/v1556795025/placeholderirs.png'
    },
    deleteItem (data) {
      this.delete_id = data.id
      this.$confirm('Yakin akan hapus ?', { color: 'red',title:'Hapus',icon:'fa-danger' }).then(res => {
        if (res) {
          this.delete_news(this.delete_id)
        }
      })
    },
    upload: function (files) {
      this.addnews.image = files[0]
      this.showPreview(files[0])
    },
    showPreview: function (file) {
      var reader = new FileReader()
      if(file){
        this.uploadImage(file);
      }
      reader.onload = function (e) {
        document.getElementById('imgnewsedit').src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    openfile () {
      document.getElementsByName('imageupload')[0].click()
    },
    formatDate (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    },
    statusformat (value) {
      let a = 'Non-Active'
      if (value === 1) {
        a = 'Active'
      }
      return a
    }
  }
}
</script>

<style lang="stylus" scoped>
.quill {
  height: 300px;
  padding-bottom: 95px;
}

.imgslidelist {
  width: 300px;
  height: 100px;
}

.tdlist {
  padding: 10px !important;
}
</style>
